import './index.scss'
import { useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import VetaImg from '@/assets/image/home/Veta_logo.png'
import { Link } from 'react-router-dom'
import DisplayText from '../../../../components/DisplayText';

const VetaLogo = () => (
  <div className="thesis-acc-logo mt-[-12px]">
    <img src={VetaImg} className={`w-[86px] h-[44px]`}/>
  </div>
)

const layers = [
  {
    id: 1,
    label: 'Control',
    content: (
      <div className="thesis-acc-content">
        <VetaLogo />
        <p className="thesis-acc-desc mt-[-20px]">
          Veta is Vishwa's first control system.<br />
          Veta enforces constraints before execution.
        </p>
        <Link to="https://www.vetagate.com/" target={"_blank"} className="thesis-acc-btn">Learn More</Link>
      </div>
    ),
  },
  {
    id: 2,
    label: 'Verification primitives',
    content: (
      <div className="thesis-acc-content">
        <p className="thesis-acc-desc">Standards that prove what an agent is allowed to do - before execution.</p>
        <div className={`flex`}>
          <div className="thesis-acc-brand w-[305px]">
            <p className={`thesis-acc-brand-title`}>ERC-8150</p>
            <p className="thesis-acc-desc min-h-[60px] mb-[12px]">
              A standard for pre-execution zero-knowledge verification of agent payments and transactions</p>
            <Link to="/erc" target={'_blank'} className="thesis-acc-btn">Learn More</Link>
          </div>
          <div className="thesis-acc-brand w-[305px]">
            <p className={`thesis-acc-brand-title`}>VAEB</p>
            <p className="thesis-acc-desc min-h-[60px] mb-[12px]">Verified agent execution bundle.</p>
            <Link to="https://www.youtube.com/watch?v=YAF1P3tc9LY" target="_blank" className="thesis-acc-btn">Learn More</Link>
          </div>
          <div className="thesis-acc-brand w-[305px]">
            <p className={`thesis-acc-brand-title`}>TEE Standard</p>
            <p className="thesis-acc-desc min-h-[60px] mb-[12px]">
              Coming Soon
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: 3,
    label: 'Applications',
    content: (
      <div className="thesis-acc-content">
        <p className="thesis-acc-desc">
          Systems built on top of verifiable execution.</p>
        <div className={`flex items-start`}>
          <div className="thesis-acc-brand w-[305px]">
            <p className={`thesis-acc-brand-title flex items-center`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="29" height="27" viewBox="0 0 29 27" fill="none">
                <path
                  d="M11.8555 19.9194V17.8096L15.557 20.2018H23.9393L29.0019 24.3383V26.9796H20.2046L11.8555 19.9194Z"
                  fill="#F2F2F2" />
                <path
                  d="M18.1211 10.8027L8.4541 10.7881H8.26172L8.13867 10.9365L0.977539 19.6387L0.883789 19.751V26.9883H0.306641V19.3027L7.92578 10.2578H17.751L26.6143 0H27.6436L18.1211 10.8027ZM28.4072 8.69727L21.5186 16.8467H11.6104L8.9043 19.585V26.9883H1.7002V20.042L8.64453 11.6045L18.3057 11.6191H18.4902L18.6123 11.4805L28.4072 0.365234V8.69727Z"
                  fill="#F2F2F2" />
                <path
                  d="M8.98199 0.0117188H0V2.67286L5.27962 6.68936H13.2655L17.4991 9.31745V7.13564L8.98199 0.0117188Z"
                  fill="#F2F2F2" />
              </svg>
              <span style={{fontSize: '22px'}}>PredX</span>
            </p>
            <p className="thesis-acc-desc min-h-[78px] mb-[12px]">
              Prediction markets on live news - for humans and agents.
            </p>
            <Link to="https://PredX.me" target="_blank" className="thesis-acc-btn">Learn More</Link>
          </div>

          <div className="thesis-acc-brand w-[305px] ml-[128px] mr-[128px]">
            <p className={`thesis-acc-brand-title`}>Voyager</p>
            <p className="thesis-acc-desc min-h-[78px] mb-[12px]">
              Automated capital deployment across lending and RWA yield strategies.
            </p>
            <Link
              to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz"
              target="_blank" className="thesis-acc-btn">Request Material</Link>
          </div>

          <div className="thesis-acc-brand w-[305px]">
            <p className={`thesis-acc-brand-title`}>Naro</p>
            <p className="thesis-acc-desc min-h-[78px] mb-[12px]">
              Guardrailed AI vaults where curators manage allocation, rebalancing, and risk - with every action gated by Veta before execution.
            </p>
            <Link
              to="https://docsend.com/v/y9j38/naro-ciara_ai_vault_curator_1pager"
              target="_blank" className="thesis-acc-btn">Learn More</Link>
          </div>

        </div>
      </div>
    )
  }
]

const Thesis = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [openId, setOpenId] = useState(1);

  const toggle = (id) => setOpenId(prev => prev === id ? null : id);

  return (
    <div className={`thesis w-1340 ${isMobile ? 'py-[60px] px-[20px]' : 'pb-[160px]'}`}>
      <h2 className={`mb-[90px] thesis-reveal h-[156px]`} style={{ '--thesis-reveal-delay': '0ms' }}>
        <DisplayText fullText="The system that enables agent-native finance" desktopFontSize={56} />
      </h2>
      <div className="thesis-acc-list">
        {layers.map(layer => {
          const isOpen = openId === layer.id;
          return (
            <div
              key={layer.id}
              className="thesis-acc-item thesis-reveal"
              style={{ '--thesis-reveal-delay': `${layer.id * 220}ms` }}
            >
              <div
                className="thesis-acc-header"
                onClick={() => toggle(layer.id)}
              >
                <div className="thesis-acc-label">
                  <span>Layer {layer.id}</span>
                  <span>{layer.label}</span>
                </div>
                <span className={`thesis-acc-arrow ${isOpen ? 'thesis-acc-arrow--down' : ''}`}>
                  {isOpen ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M10 17L15 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M15 12L10 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M10 17L15 12" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                      <path d="M15 12L10 7" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                  )}
                </span>
              </div>
              <div className={`thesis-acc-panel ${isOpen ? 'thesis-acc-panel--open' : ''}`} aria-hidden={!isOpen}>
                <div className="thesis-acc-panel-inner">
                  {layer.content}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Thesis
